import { ChatResponse } from "../models/chat.model";
import { axiosAgentClient } from "./http-client.service";

export async function chat(
  agentId: string,
  query: string
): Promise<ChatResponse> {
  const response = await axiosAgentClient.post(`/chat/with-agent/${agentId}`, {
    query,
  });
  return response.data;
}

export async function getChatHistory(
  threadId: string
): Promise<ChatResponse[]> {
  const response = await axiosAgentClient.get(`/chat/history/${threadId}`);
  return response.data ?? [];
}

export async function clearChatHistory(threadId: string): Promise<void> {
  await axiosAgentClient.delete(`/chat/history/${threadId}`);
}

export async function getSpeechFromText(text: string): Promise<Blob> {
  const response = await axiosAgentClient.post(
    `/speech/from-text`,
    {
      query: text,
    },
    {
      responseType: "blob", // Important: tells Axios to treat response as binary blob
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
}